import React, { useState, useEffect } from "react";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";

const Header = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const scrollToSection = (sectionId) => {
    const headerOffset = 80; // Height of fixed header + some padding
    const elementPosition = (element) => element.getBoundingClientRect().top;
    const offsetPosition = (element) =>
      window.pageYOffset + elementPosition(element) - headerOffset;

    if (location.pathname === "/") {
      const element = document.getElementById(sectionId);
      if (element) {
        window.scrollTo({
          top: offsetPosition(element),
          behavior: "smooth",
        });
      }
    } else {
      navigate("/");
      // Small delay to ensure the Home component is mounted
      setTimeout(() => {
        const element = document.getElementById(sectionId);
        if (element) {
          window.scrollTo({
            top: offsetPosition(element),
            behavior: "smooth",
          });
        }
      }, 100);
    }
  };
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  return (
    <header>
      {/* Navigation Bar */}
      <nav
        className="navbar navbar-expand-lg navbar-dark fixed-top"
        style={{ backgroundColor: "rgb(42, 74, 127)", zIndex: 1030 }}
      >
        <style jsx>{`
          .navbar-nav .nav-link {
            color: white !important;
            text-decoration: none !important;
            position: relative;
            padding: 8px 15px;
          }
          .navbar-nav .nav-link:hover {
            opacity: 0.8;
          }
          .navbar-nav .nav-link::after {
            content: none !important;
          }
          .navbar-nav .nav-link.active {
            font-weight: 500;
          }
          @media (max-width: 991.98px) {
            .navbar-collapse {
              background-color: rgb(42, 74, 127);
              padding: 15px;
              margin-top: 10px;
              border-radius: 5px;
            }
            .navbar-nav {
              margin-top: 10px;
            }
            .navbar-toggler {
              border-color: rgba(255,255,255,0.5);
            }
            .navbar-toggler:focus {
              box-shadow: 0 0 0 0.15rem rgba(255,255,255,0.25);
            }
          }
        `}</style>
        <div className="container">
          <div className="logo">
            <Link to="/">
              <img
                src="/asia-logo.png"
                alt="Asia-Pacific Academic Press"
                style={{ height: "60px" }}
              />
            </Link>
          </div>
          <button
            className="navbar-toggler"
            type="button"
            onClick={toggleMenu}
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className={`collapse navbar-collapse ${isMenuOpen ? "show" : ""}`}
            id="navbarNav"
          >
            <ul className="navbar-nav ms-auto">
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsMenuOpen(false);
                    if (location.pathname === "/") {
                      scrollToSection("hero");
                    } else {
                      navigate("/");
                      // The scroll will be handled after navigation
                      setTimeout(() => {
                        const element = document.getElementById("hero");
                        if (element) {
                          const headerOffset = 80;
                          const elementPosition =
                            element.getBoundingClientRect().top;
                          const offsetPosition =
                            window.pageYOffset + elementPosition - headerOffset;
                          window.scrollTo({
                            top: offsetPosition,
                            behavior: "smooth",
                          });
                        }
                      }, 100);
                    }
                  }}
                  activeClassName="active"
                  exact
                >
                  Home
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsMenuOpen(false);
                    scrollToSection("journals");
                  }}
                  activeClassName="active"
                >
                  Our Journal
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsMenuOpen(false);
                    scrollToSection("about");
                  }}
                  activeClassName="active"
                >
                  About
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsMenuOpen(false);
                    scrollToSection("publication-procedure");
                  }}
                  activeClassName="active"
                >
                  Publication Procedure
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="/author-guidelines"
                  onClick={() => setIsMenuOpen(false)}
                  activeClassName="active"
                >
                  Guidelines
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsMenuOpen(false);
                    scrollToSection("benefits");
                  }}
                  activeClassName="active"
                >
                  Benefits
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsMenuOpen(false);
                    scrollToSection("licence");
                  }}
                  activeClassName="active"
                >
                  Licence & Indexing
                </NavLink>
              </li>
              <li className="nav-item">
                <NavLink
                  className="nav-link"
                  to="#"
                  onClick={(e) => {
                    e.preventDefault();
                    setIsMenuOpen(false);
                    scrollToSection("contact");
                  }}
                  activeClassName="active"
                >
                  Contact Us
                </NavLink>
              </li>
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

export default Header;
